import styled from 'styled-components';

export const OrangeBigDot = styled.div`
  width: 20px;
  height: 20px;
  background-color: var(--yellow);
  border-radius: 100%;
  margin-right: 10px;
`;
